import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs/Observable';

@Pipe({
  name: 'pollAnswersQuestion',
})
export class PollAnswersQuestionPipe implements PipeTransform {

  constructor() { }

  transform(answers: any[], answerId: string) {
    return answers.map(item => item.answers[answerId]);
  }
}



// WEBPACK FOOTER //
// ./src/pipes/poll/poll-answer-question..ts